import * as React from 'react';
import { IArticlesData } from 'models/magazine/article/articles';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { ItemCardList } from 'components';
import { ErrorPage } from 'containers';
import { IArticleCardAction } from 'models/magazine/article/articlecard';

interface IProps {
	similarArticles?: IArticlesData;
	tags: string;
	t?: (key: string) => string;
	getArticleCard?: (id: string) => IArticleCardAction;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SimilarArticles extends React.Component<IProps, any> {
	public render() {
		if (this.props.similarArticles.error) {
			return <ErrorPage {...this.props} message={this.props.similarArticles.message} />;
		}

		const { items } = this.props.similarArticles;
		const { t } = this.props;
		const listPropsDesktop: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_SIMILAR_ARTICLE_DESKTOP_ITEM_CARD,
			goToCard: (id: string) => this.props.getArticleCard(id),
		};

		return (
			<div className="similarArticles">
				<div className="container containerFix">
					<div className="row">
						<div className="sectionTitle col-md-12 no_pad">
							<h2 className="articlePostsText">{t('Magazine_Sidebar_MoreArticles_Title')}</h2>
						</div>
					</div>
					<div className="row padFix articlesContainer d-flex flex-column">
						<div className="col-md-12 no_pad">
							<div className="container containerFix">
								<div className="row">
									<ItemCardList {...listPropsDesktop} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export { SimilarArticles };
